import React from 'react';
import { useForm } from 'react-hook-form';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import { TextInputField, TextAreaField } from 'components/forms';

export default function DetailsStep() {
  const { nextStep, data } = useWizard();
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      subject: data.subject || '',
      message: data.message || ''
    }
  });

  const onSubmit = (formData) => {
    nextStep(formData);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <WizardStepLayout
        title="Reminder Details"
        description="Add a subject and message for your reminder."
        primaryAction={{ label: 'Review', type: 'submit' }}
      >
        <div className="space-y-6 max-w-md mx-auto">
          <TextInputField
            name="subject"
            labelText="Subject"
            register={register}
            registerOptions={{ required: 'Subject is required' }}
            errors={errors}
            placeholder="e.g., Pay bills"
          />

          <TextAreaField
            name="message"
            labelText="Message"
            register={register}
            registerOptions={{ required: 'Message is required' }}
            errors={errors}
            placeholder="Add any additional details..."
            rows={4}
          />
        </div>
      </WizardStepLayout>
    </form>
  );
}
